import * as actionTypes from '../constants/actions';

export function dispatchError(data) {
	return function(dispatch) {
		dispatch({
			type: actionTypes.RECV_ERROR,
			payload: data,
		});

		if (data.message && (data.message === 'Login is required' || data.message === 'Requires login')) {
			dispatch({
				type: actionTypes.USERS_LOGOUT,
			});
		}
	};
}

export function dispatchMsg(data) {
	return function(dispatch) {
		dispatch({
			type: actionTypes.RECV_MSG,
			payload: data,
		});
	};
}

export function clearErrors() {
	return function(dispatch) {
		dispatch({
			type: actionTypes.CLEAR_ERROR,
		});
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/errors.js
 **/